export const OwnerOrganisations = {
    HGSS: { 
      id: 'hgss', code : 20, display : "HGSS", shortDisplay : "HGSS" 
    },
    HPS: { 
      id: "hpss", code: 30, display: "HPS", shortDisplay: "HPS"
    },

  }
  